export class Users{
nom:string;
prenom:string;

email:string;
password:string;
passwordConfirm:string;
}
